<template>
  <div class="pwd">
    <el-card class="msg">
      <div class="title">{{ $t("perOrderXiang.theOrderDetails") }}</div>

      <div class="top">
        <el-row>
          <el-col span="12">{{ $t("perOrderXiang.productDetails") }}</el-col>
          <el-col span="4">{{ $t("perOrderXiang.unitPrice") }}</el-col>
          <el-col span="4">{{ $t("perOrderXiang.quantity") }}</el-col>
          <el-col span="4">{{ $t("perOrderXiang.subtotal") }}</el-col>
        </el-row>
      </div>
      <div class="box">
        <div
          v-for="item in product.orderProductList"
          :key="item.id"
          style="padding: 0.9375rem 0; border-bottom: 0.0625rem solid #eee"
        >
          <div class="chanpin">
            <el-row>
              <el-col span="12">
                <img
                  :src="
                    (item.productPicture &&
                      item.productPicture.split(',')[0]) ||
                      ''
                  "
                  alt=""
                />
                <div class="name">{{ item.productTitle }}</div>
              </el-col>
              <el-col span="4">
                <span style="color: red"
                  >{{ $t("perOrderXiang.salesPrice") }}￥{{
                    item.salesAmount
                  }}</span
                >
                <br />
                {{ $t("perOrderXiang.theOrderDetails") }}￥{{
                  item.discountAmount
                }}
                <br />
                <span class="hui"
                  >{{ $t("perOrderXiang.originalPrice") }}￥{{
                    item.productAmount
                  }}</span
                >
              </el-col>
              <el-col span="4"> x{{ item.productNumber }} </el-col>
              <!-- 计算总价 -->
              <el-col span="4">
                ￥{{ item.productNumber * item.salesAmount }}
              </el-col>
            </el-row>
          </div>
          <div class="h2 lan">
            {{ $t("perOrderXiang.productConfiguration") }}
          </div>
          <ul>
            <li
              v-for="configs in JSON.parse(item.productConfig) || []"
              :key="configs"
            >
              <span class="left">{{ configs.label }}</span>
              <span>{{ configs.value }}</span>
            </li>
          </ul>
        </div>
      </div>
      <div class="ft">
        <div class="fr">
          <div class="jin">
            {{ $t("perOrderXiang.totalorderAmount") }}
            <span class="red">￥{{ product.salesAmount }}</span>
          </div>
          <div
            class="fr but"
            @click="rebackOrder()"
            v-if="product.orderStatus != 4"
          >
            {{ $t("perOrderXiang.cancelTheOrder") }}
          </div>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
import ElementUI from "element-ui";

export default {
  data() {
    return {
      id: this.$route.query.productId,
      product: {
        createTime: "", //	创建时间	string(date-time)
        discountAmount: 0, //	折扣金额	number
        id: 0, //	id	integer(int64)
        orderCode: "", //	订单编号	string
        productAmount: 0, //	产品金额	number
        productConfig: "", //	产品配置	string
        productNumber: 0, //	产品数量	integer(int32)
        productPicture: "", //	产品图片	string
        productTitle: "", //	产品标题	string
        productVideo: "", //	产品视频	string
        userId: 0, //	用户id
      },
    };
  },
  mounted() {
    document.addEventListener("keydown", function(e) {
      if (e.key === "F12" || e.keyCode === 123) {
        e.preventDefault();
      }
    });
    document.addEventListener("contextmenu", function(e) {
      e.preventDefault();
    });


    this.init(this.$route.query.productId);
  },
  methods: {
    async init(orderCode) {
      let { data: res } = await this.$http.get(`/c/order/get/${orderCode}`);
      if (res.code != 200) {
        return this.$message.error(res.message);
      }
      this.product = res.data;
    },
    //撤销订单
    rebackOrder() {
      // console.log(ElementUI);
      ElementUI.MessageBox.confirm("此操作将撤销该订单, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let { data: res } = await this.$http.post(
            `/c/order/cancel/${this.$route.query.productId}`
          );
          if (res.code != 200) {
            return this.$message.error(res.message);
          }

          this.init(this.$route.query.productId);
          this.$message({
            type: "success",
            message: "撤销成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消撤销",
          });
        });
    },
  },
};
</script>
<style lang="less" scoped>
.msg {
  // width: 60rem;
  //   height: 46.875rem;
  .title {
    color: rgb(67, 188, 183);
    line-height: 2.5rem;
    border-bottom: 0.25rem solid rgb(67, 188, 183);
  }
  .top {
    line-height: 3.125rem;
    height: 3.125rem;
    background-color: #f1f1f1;
    padding-left: 1.25rem;
    margin-top: 1.25rem;
  }
  .box {
    border: 0.0313rem solid #ccc;
    margin-top: 1.25rem;
    padding: 1.25rem;
    .chanpin {
      height: 7.5rem;
      border-bottom: 0.0313rem solid #ccc;
      line-height: 1.875rem;
      img {
        width: 6.25rem;
        height: 6.25rem;
        float: left;
        margin-right: 1.25rem;
        border: 0.0313rem solid #ccc;
      }
    }
    .h2 {
      line-height: 3.125rem;
    }
    ul {
      li {
        display: block;
        line-height: 2.75rem;
        height: 2.75rem;
        .left {
          display: inline-block;
          width: 13.75rem;
        }
      }
    }
  }
  .ft {
    margin-top: 1.875rem;
    height: 10rem;
    .jin {
      height: 3.125rem;
      border: 0.0313rem solid rgb(67, 188, 183);
      line-height: 3.125rem;
      padding: 0 3.125rem;
    }
  }
  .ft .fr .fr {
    height: 2.5rem;
    line-height: 2.5rem;
    margin-top: 0;
    padding: 0 2.5rem;
    box-sizing: border-box;
    border-radius: 0;
  }
}
</style>
